<app-circle style="position: fixed; left:0; top: 0; z-index: -1 !important;"
            *ngFor="let circle of circleCount"></app-circle>
